import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { Nationality } from '../../api/models';

export type TABLE_TYPE = Table<Nationality>;

export const TABLE = 'nationality';
const SCHEMA = 'nationality, country';

class NationalityDatabase implements DataRepository<Nationality> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<Nationality | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: Nationality, key: Key): Promise<Nationality> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: Nationality[]): Promise<Nationality[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<Nationality[]> {
    return this.db[TABLE].toArray();
  }
}

export const NationalityDB = new NationalityDatabase(db);
